/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyright': '由 Atlassian Intelligence 提供技術支援',
  'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyrightShort': '由 AI 提供技術支援',
  'fabric.editor.ai.commandPalette.footer.disclaimerText': '內容取決於您的權限，其品質可能會有所不同',
  'fabric.editor.ai.commandPalette.footer.disclaimerTextShort': '內容品質可能會有所不同',
  'fabric.editor.ai.commandPalette.footer.disclaimerTextUpdated': '使用人工智慧。驗證結果。',
  'fabric.editor.ai.commandPalette.footer.infoIconLabel': '資訊',
  'fabric.editor.ai.commandPalette.footer.rovoCopyright': 'Rovo',
  'fabric.editor.ai.commandPalette.footer.usePageKnowledgeToggleLabel': '包含目前頁面中的知識',
  'fabric.editor.ai.commandPalette.promptForm.logo': 'Atlassian Intelligence 標誌',
  'fabric.editor.ai.components.backIconButton.backLabel': '返回',
  'fabric.editor.ai.components.cancelEscButton.cancelLabel': '取消',
  'fabric.editor.ai.components.cancelEscButton.escLabel': '離開',
  'fabric.editor.ai.components.cancelIconButton.cancelLabel': '取消',
  'fabric.editor.ai.components.cancelIconButton.cancelTooltip': '取消',
  'fabric.editor.ai.components.feedbackForm.badResponse': '回應不良',
  'fabric.editor.ai.components.feedbackForm.feedbackSent': '已傳送意見反應',
  'fabric.editor.ai.components.feedbackForm.goodResponse': '回應良好',
  'fabric.editor.ai.config.item.action.continueFromLatestResponse': '從最後回應繼續',
  'fabric.editor.ai.config.item.action.copyResponse': '複製',
  'fabric.editor.ai.config.item.action.responseCopied': '已複製！',
  'fabric.editor.ai.config.item.action.responseCopiedToClipboard': '已複製到剪貼簿',
  'fabric.editor.ai.config.item.action.retryPrompt': '重試',
  'fabric.editor.ai.experience-application.documentInsertError':
    '我們在插入回應時遇到問題。請關閉對話方塊，然後再試一次。',
  'fabric.editor.ai.experience-application.tokenLimitExceeded':
    '我們無法取得回應。您的提示或回應已超過此要求的限制。請關閉對話方塊，然後再試一次。',
  'fabric.editor.ai.experience.apiError': '我們無法收到回覆，請再試一次。',
  'fabric.editor.ai.experience.commandPaletteAriaName': 'Atlassian Intelligence',
  'fabric.editor.ai.experience.commandPaletteV2Placeholder': '告訴 AI 要怎麼做...',
  'fabric.editor.ai.experience.inputTooShortError': '內容太短，無法總結。請新增更多內容並再試一次。',
  'fabric.editor.ai.experience.loadingAriaTitle': '正在產生',
  'fabric.editor.ai.experience.previewScreenLabel': '預覽',
  'fabric.editor.ai.experience.rovoAgents.agentPalette.placeholder': '請客服人員撰寫任何內容或從下方選擇',
  'fabric.editor.ai.experience.rovoAgents.productLabel': 'Rovo',
  'fabric.editor.ai.experience.rovoAgents.productLogoAltText': 'Rovo 標誌',
  'fabric.editor.ai.screens.UserInputCommamdPalette.footerText': 'Atlassian Intelligence',
  'fabric.editor.ai.screens.discard.cancelLabel': '返回',
  'fabric.editor.ai.screens.discard.discardLabel': '捨棄',
  'fabric.editor.ai.screens.error.warningIconLabel': '警告',
  'fabric.editor.ai.screens.error.ariaErrorTitle': '錯誤',
  'fabric.editor.ai.screens.error.cancelLabel': '取消',
  'fabric.editor.ai.screens.error.retryLabel': '再試一次',
  'fabric.editor.ai.screens.loading.adfContentAriaLiveRegionDescription': '即時更新的內容：',
  'fabric.editor.ai.screens.loading.iconAltText': '正在產生圖示',
  'fabric.editor.ai.screens.preview.actionButtonsAccept': '接受',
  'fabric.editor.ai.screens.preview.actionButtonsAccessibleLabel': '人工智慧生成內容的動作',
  'fabric.editor.ai.screens.preview.actionButtonsTryAgain': '再試一次',
  'fabric.editor.ai.screens.preview.betaLabel': '測試版',
  'fabric.editor.ai.screens.preview.cancelLabel': '取消',
  'fabric.editor.ai.screens.preview.compactFeedbackText': '有幫助嗎？',
  'fabric.editor.ai.screens.preview.defaultAIPlaceholder': '告訴 AI 下一步該怎麼做',
  'fabric.editor.ai.screens.preview.discardLabel': '捨棄',
  'fabric.editor.ai.screens.preview.disclaimer': '資訊品質可能會有變化。',
  'fabric.editor.ai.screens.preview.disclaimerLink': '了解原因',
  'fabric.editor.ai.screens.preview.header.clear.hover': '清除',
  'fabric.editor.ai.screens.preview.header.edit': '編輯提示',
  'fabric.editor.ai.screens.preview.header.edit.hover': '編輯',
  'fabric.editor.ai.screens.preview.placeholderWithAgent': '詢問 {agentName} 接下來要做什麼',
  'fabric.editor.ai.screens.preview.refineButton': '微調',
  'fabric.editor.ai.screens.preview.refineDropdown.refineButton': '微調',
  'fabric.editor.ai.screens.prompt.logoAltText': 'Atlassian Intelligence 標誌',
  'fabric.editor.ai.screens.prompt.logoText': 'Atlassian Intelligence',
  'fabric.editor.ai.screens.prompt.streaming.insertMenu.addLink': '新增連結',
  'fabric.editor.ai.screens.prompt.streaming.insertMenu.mention': '提及使用者',
  'fabric.editor.ai.screens.prompt.streaming.insertMenu.triggerLabel': '插入豐富內容',
  'fabric.editor.ai.screens.prompt.streaming.placeholder': '描述您想做的事',
  'fabric.editor.ai.screens.prompt.streaming.record': '錄製',
  'fabric.editor.ai.screens.prompt.streaming.submit': '提交',
  'fabric.editor.ai.screens.prompt.submitLabel': '提交',
  'fabric.editor.ai.screens.prompt.submitTooltip': '傳送至 AI',
  'fabric.editor.ai.screens.promptWithSelectedOption.promptSelected': '{promptName} - 已選取',
  'fabric.editor.ai.screens.promptWithSelectedOption.removeLabel': '移除',
  'fabric.editor.ai.shared.aiProactiveButtonLabel': '建議',
  'fabric.editor.ai.shared.aiUniversalDescriptor': '寫作助理',
  'fabric.editor.ai.shared.aiUniversalLongCallToAction': '讓 Atlassian Intelligence 協助您寫作',
  'fabric.editor.ai.shared.aiUniversalShortCallToAction': '撰寫',
  'fabric.editor.ai.shared.betaLabel': '測試版',
  'fabric.editor.ai.shared.generateContent.aiButtonTitle': 'AI (Atlassian Intelligence)',
  'fabric.editor.ai.ui.components.suggestions.betaLozenge': '測試版',
  'fabric.editor.ai.ui.components.suggestions.newLozenge': '新功能',
  'fabric.editor.ai.ui.components.suggestions.tellAILabel': '告訴 AI',
  'fabric.editor.ai.ui.components.suggestions.tellAgentLabel': '告訴客服人員',
};
